import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/domine/600.css"
import "@fontsource/inter/300.css"
import "@fontsource/inter/300-italic.css"
import "@fontsource/inter/600.css"
import "@fontsource/inter/700.css"

import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
export const wrapRootElement = ({ element }) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}> 
        { element }
         </GoogleReCaptchaProvider>
    )
}
